/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import store from './store'
import router from './routes'
import { installFastLoading } from './services/fast-loading'
import { observeListTables } from './directives/col-resize'
import { scanActionTips, destroyActionTips } from './directives/action-tip'
import { scanRowActions, closeRowActionMenu } from './directives/row-actions'
import { scanTableCells } from './directives/table-cells'

installFastLoading(Vue);

function scanListUi(el) {
    scanRowActions(el);
    scanActionTips(el);
    scanTableCells(el);
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#root',
    store,
    router,
    mounted() {
        const preloader = document.querySelector('.preloader, .js-preloader');
        if (preloader) preloader.style.display = 'none';
        observeListTables(this.$el, scanListUi);
    },
    watch: {
        $route() {
            closeRowActionMenu();
            destroyActionTips();
            this.$nextTick(() => observeListTables(this.$el, scanListUi));
        }
    }
});
